import MailIcon from '@mui/icons-material/MailOutlined';
import Stack from '@mui/material/Stack';
import { FE_ROLES } from '../../config/consts';
import { IApartment } from '../../modules/apartments/store';
import { IUser } from '../../modules/user/store';
import { EmailWithTooltip } from '../EmailWithTooltip';
import { TypographyWithEllipsisTooltip } from '../TypographyWithEllipsisTooltip';
import UserIcon from '../UserIcon';

function getApartmentInfo(apartment: { number: string; name?: string }) {
  if (apartment?.name) {
    return `${apartment.number} – ${apartment.name}`;
  }
  return apartment.number;
}

function UserInfo({ apartments, user }: { user: IUser; apartments?: IApartment[] }) {
  let apartmentsList;
  if (apartments !== undefined) {
    apartmentsList = apartments;
  } else {
    apartmentsList = user.apartments;
  }

  return (
    <Stack direction="column" spacing={1}>
      <Stack direction="row">
        <UserIcon color="secondary" sx={{ flexShrink: 0, mr: 2 }} userRole={user.role} />
        <TypographyWithEllipsisTooltip sx={{ fontWeight: 'bold', pr: 0.5 }} variant="body1">
          {user.firstName ? `${user.firstName} ${user.lastName}` : user.lastName}
        </TypographyWithEllipsisTooltip>
        {apartmentsList.length > 0 && (
          <TypographyWithEllipsisTooltip sx={{ color: 'text.secondary' }} variant="body1">
            {`(${getApartmentInfo(apartmentsList[0])}) ${
              apartmentsList.length - 1 > 0 ? ` +${apartmentsList.length - 1}` : ''
            }`}
          </TypographyWithEllipsisTooltip>
        )}
      </Stack>
      {user.role !== FE_ROLES.LOGIN_LESS && (
        <Stack direction="row">
          <MailIcon color="secondary" sx={{ flexShrink: 0, mr: 2 }} />
          <EmailWithTooltip email={user.email} variant="body1" />
        </Stack>
      )}
    </Stack>
  );
}

export default UserInfo;
